export default {
  // Endpoints
  // loginEndpoint: 'https://domatch-sqa.arqbs.com/api/auth/singin',
  loginEndpoint: 'http://localhost:8082/api/auth/singin',
  registerEndpoint: 'http://localhost:8082/api/auth/signup',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',

  // This will be prefixed in authorization header with token
  // e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken',
}
